var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 844.164,
    height: 800,
    viewBox: "0 0 844.164 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-546 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(829.657 306.037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.285,558.3l115.4-11.569-.469-1.567c-23.261-77.648-42.258-145.378-39.081-187.845a3.221,3.221,0,0,0-1.536-2.994,3.278,3.278,0,0,0-3.415-.013L245.642,435.592l16.707,34.076Z",
    transform: "translate(-241.112 -353.836)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.563,599.62a25.919,25.919,0,0,0,5.516-.6l105-22.941a22.612,22.612,0,0,0,15.461-12.549,25.653,25.653,0,0,0,.618-20.816l-40.6-99.312a13.305,13.305,0,0,0-12.961-8.552L254.335,448.6a4.509,4.509,0,0,1-4.586-3.228,5.06,5.06,0,0,1,1.517-5.666l117.684-82.972a1.652,1.652,0,0,0,.312-2.143,1.4,1.4,0,0,0-1.965-.471L251.017,427.109c-8.561,5.376-12.535,16.253-9.665,26.453L276.582,578.8C280.129,591.41,290.77,599.62,302.563,599.62Zm66-243.178-.009.005Z",
    transform: "translate(-240.428 -353.89)",
    fill: "#f59e0b"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 44.672,
    height: 58.88,
    transform: "translate(781.915 868.624)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.166,627.536H270.206a54.769,54.769,0,0,1-23.588-5.374l-17.507-8.416a10.513,10.513,0,0,1,1.751-19.607l36.115-9.993,61.786-32.476.046.234c1.155,5.849,2.945,14.693,3.173,15.229,6.336,7.259,12.846,10.6,19.346,9.944,11.34-1.15,18.878-14.243,18.953-14.376l.057-.1.115.011a7.52,7.52,0,0,1,5.837,3.183c2.586,3.9,1.009,9.91.749,10.813,3.1,3.032,4.489,19.958,4.6,21.325,4.479,4.747,6.607,9.312,6.326,13.567-.247,3.719-2.309,7.173-6.13,10.266a26.519,26.519,0,0,1-16.67,5.771Z",
    transform: "translate(453.801 340.606)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.419,225.292a61.487,61.487,0,1,0-79.909,58.676L571.4,362.524l60.6-50.5s-13.09-16.674-20.111-35.475a61.42,61.42,0,0,0,27.537-51.26Z",
    transform: "translate(692.733 24.614)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.16,236.869l-86.541,4.154-10.333,23.25s-100.212,44.515-105.916,87.832c0,0-25.858,72.119-82.666,69.748S542.787,584.6,542.787,584.6L715.868,365.022l6.458-101.632Z",
    transform: "translate(614.144 84.134)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.136,459.023l-35.079-3.974c8.935,18.963,5.806,63.243-.6,107.43C352,620.678,337.81,727.727,337.81,727.727L278.4,712.3V421.457c0-38.8,112.167-56.436,196.081-64.205,50.123-4.627,90.167-5.753,90.167-5.753L680.786,491.233Z",
    transform: "translate(498.796 177.523)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.672,
    height: 58.88,
    transform: "translate(922.237 841.849) rotate(-34.231)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.282,557.591c-2.159-3.665-6.479-6.242-12.865-7.636-.853-1.071-11.523-14.282-15.788-15.062-.289-.89-2.359-6.732-6.7-8.511a6.771,6.771,0,0,0-4.409-.237,9.746,9.746,0,0,0-2.214.89l-.109.054.018.109c.018.162,1.137,15.226-7.585,22.558-5.009,4.191-12.267,5.1-21.594,2.668-.487-.325-6.932-6.624-11.179-10.815l-.182-.162-.344.635-32.465,60.975-24.226,28.582a10.5,10.5,0,0,0,9.585,17.185l19.195-2.885a54.964,54.964,0,0,0,22.521-8.818l78.523-53.426a26.559,26.559,0,0,0,10.524-14.155C477.406,564.838,477.17,560.828,475.282,557.591Z",
    transform: "translate(543.396 319.598)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.891,483.44c35.712,59.232,71.826,155.83,71.826,155.83l-9.748,3.485L426.506,658.29l-4.591,1.651L372.2,586.9c-28.562-41.992-62.535-91.933-82.061-120.605V445.875c0-38.8,112.167-56.436,196.08-64.205L373.09,441.247C383.7,447.516,395.77,463.314,407.891,483.44Z",
    transform: "translate(508.347 202.105)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.408,326.354h0a48.175,48.175,0,0,0-75.521,1.324L606.321,522.17l-236.8-27.232a42.646,42.646,0,0,0-47.393,39.1h0a42.646,42.646,0,0,0,36.452,45.49l271.554,39.038A92.574,92.574,0,0,0,723.4,573.355L834.85,381.081a48.175,48.175,0,0,0-4.443-54.727Z",
    transform: "translate(534.326 142.692)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.583,
    height: 264.576,
    transform: "translate(923.144 703.609)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.583,
    height: 264.576,
    transform: "translate(1153.613 703.609)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.242,350.332l57.107,25.737-15.026,33.344-57.109-25.737a38.386,38.386,0,0,1-29.648-1.326c-17.8-8.022-26.85-26.468-20.21-41.2S412.809,320.978,430.609,329a38.389,38.389,0,0,1,20.633,21.333Z",
    transform: "translate(584.983 156.175)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.255,286.135l-46.5,134.332-108.5-33.583-20.667,56.833,160.9,44.105,97.781-173.8",
    transform: "translate(617.093 124.27)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.164,2.629H0V-1H844.164Z",
    transform: "translate(546 967.371)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5,172.472s-.876,22.8-28.319,26.1l-55.671,6.677s36.51-119.2,18.312-104.461S40.86,66.1,40.86,66.1L28.255,96.15s-37.694-9.817-.281-45.906c0,0,44.756-41.76,98.028-24.132s55.506,146.359,55.506,146.359Z",
    transform: "translate(1182.127 148.229)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.dde457a329c8d73ba6f3e71c9e2df8cd.svg";
export { ForwardRef as ReactComponent };